module.exports = __webpack_public_path__ + "img/UI_shouji_APR_01_f29237e8f.png";